import { render, staticRenderFns } from "./EditDefectModal.vue?vue&type=template&id=390e11cc&"
import script from "./EditDefectModal.vue?vue&type=script&lang=js&"
export * from "./EditDefectModal.vue?vue&type=script&lang=js&"
import style0 from "./EditDefectModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports